import { module } from 'angular';
import templateBuilderWellDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/well/display.html', templateBuilderWellDisplay);
});
